export default __webpack_public_path__ + "static/media/headgear-right.62f87996.PNG";